import { useState } from 'react';
import ReservesApi from '../../../../../API/warehouse/reserves-api';
import { TYPE_BUTTONS } from '../../../../../constans';
import { Row } from '../../../../../components/Basic/Blocks';
import { Input } from '../../../../../components/Basic/Inputs';
import { Button } from '../../../../../components/Basic/Buttons';

const Dereserving = ({ reserved, id, readOnly = false, get }) => {
  const [value, setValue] = useState(0);

  const dereserving = () => {
    ReservesApi.dereserve({ data: { reservedProductId: id, quantity: parseInt(value) } }).then(() => {
      get();
      setValue(0);
    });
  };

  return (
    <Row>
      <Input
        value={value}
        onChange={v => setValue(v)}
        style={{ width: '50px', marginRight: '10px' }}
        center
        readOnly={readOnly}
      />
      <Button
        type={TYPE_BUTTONS.WHITE}
        style={{ padding: '5px 12px' }}
        disabled={value === 0 || value === '0' || value > reserved}
        onClick={dereserving}
      >
        Ок
      </Button>
    </Row>
  );
};

export default Dereserving;
